module.exports = __webpack_public_path__ + "media/images/products/marketplace/2-e803a27d7b89fd186b44228a752a0a40.jpg";